import { HttpErrorResponse } from '@angular/common/http';

export const MAINTENANCE_ROUTE = 'maintenance';
export const MAINTENANCE_HEADER = 'X-Maintenance';
export const MAINTENANCE_ERROR_CODE = 'MAINTENANCE';

/** Shape of `/maintenance.json` served from the S3 bucket root. */
export interface MaintenanceInfo {
  enabled: boolean;
  message?: string;
  /** ISO date-time of the expected end of maintenance. */
  eta?: string;
  /** Lets admins skip the flag-based screen via `?maintenanceBypass=<token>`. */
  bypassToken?: string;
}

/** 503 with `X-Maintenance: true` header or `{ code: 'MAINTENANCE' }` body. */
export function isMaintenanceResponse(
  error: unknown
): error is HttpErrorResponse {
  return (
    error instanceof HttpErrorResponse &&
    error.status === 503 &&
    (error.headers?.get(MAINTENANCE_HEADER) === 'true' ||
      error.error?.code === MAINTENANCE_ERROR_CODE)
  );
}
